import axios from "axios";
import { clearStoredAuth, getStoredAuth } from "./auth";

const baseURL = process.env.VUE_APP_API_BASE_URL || "/api";

export const api = axios.create({
    baseURL
});

api.interceptors.request.use((config) => {
    const token = getStoredAuth();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Basic ${token}`;
    }

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            clearStoredAuth();
            if (window.location.pathname !== '/login') {
                const redirect = `${window.location.pathname}${window.location.search}`;
                window.location.assign(`/login?redirect=${encodeURIComponent(redirect)}`);
            }
        }

        return Promise.reject(error);
    }
);
